import { render, staticRenderFns } from "./MoreData.vue?vue&type=template&id=42f6f22c&scoped=true&"
import script from "./MoreData.vue?vue&type=script&lang=js&"
export * from "./MoreData.vue?vue&type=script&lang=js&"
import style0 from "./MoreData.vue?vue&type=style&index=0&id=42f6f22c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f6f22c",
  null
  
)

export default component.exports